var NOPRepository = {
    Practitioner: {
        save(id, name, surname, practice_number, qualification, university, title, photo, successCB) {
        },
        create(id, name, surname, practice_number, qualification, university, title, photo, successCB) {
        },
        update(id, name, surname, practice_number, qualification, university, title, photo, successCB) {
        },
        find(id, successCB) {
        }
    },
    Chat: {
        save(id, user_id, practitioner_id, date_started, date_ended, successCB) {
        },
        create(id, user_id, practitioner_id, date_started, date_ended, successCB) {
        },
        update(id, user_id, practitioner_id, date_started, date_ended, successCB) {
        },
        find(id, successCB) {
        },
        all(userid, successCB) {

        }
    },
    Message: {
        save(id, chat_id, message, type, timestamp, practitioner_id, successCB) {
        },
        create(id, chat_id, message, type, timestamp, practitioner_id, successCB) {
            db.executeSql("INSERT INTO chat_messages (id, chat_id, message, type, timestamp, practitioner_id) VALUES(?, ?, ?, ?, ?, ?)",
                [id, chat_id, message, type, timestamp, practitioner_id], function (result) {
                    successCB(result);
                }
            );
        },
        update(id, chat_id, message, type, timestamp, practitioner_id, successCB) {
        },
        find(id, successCB) {
        }
    },
    close() {
    }
}

module.exports = NOPRepository;